export enum SiteType {
  BUS = 'BUS',
  SHIP = 'SHIP'
}



// WEBPACK FOOTER //
// ./src/environments/site-type.ts